import { ContainerDetail } from "../../Models/OmsPackOrderDetails";
import { Commission, PaymentMethod } from "../../Models/ProCoverageApiResponse";
import { CoverageOption, CartItem, OrderSummary } from "../../Models/ProCoverageApiResponse";


const dummyCommissions: Commission[] = [
  { id: 'comm1', employeeNumber: 'E101', employeeName: 'Alice Johnson', percentage: '5.50', commissionType: 'Sales' }, // Changed to string
  { id: 'comm2', employeeNumber: 'E102', employeeName: 'Bob Williams', percentage: '2.00', commissionType: 'Referral' }, // Changed to string
];

const apiService = {
  getCoverageOptions: async (): Promise<CoverageOption[]> => {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [
      {
        WarrantyType: "Replacement",
        UnitPrice: "23.99",
        UnitOfMeasure: "EACH",
        WarrantyCondition: "New",
        ExtendedDisplayDescription: "Warranty PCRC 100-149.99 24",
        ItemID: "J02486000001000",
        months: 24,
        primeLineNumber: "1"
      },
      {
        WarrantyType: "Replacement",
        UnitPrice: "15.00",
        UnitOfMeasure: "EACH",
        WarrantyCondition: "New",
        ExtendedDisplayDescription: "Warranty PRO 50-99.99 12",
        ItemID: "J01234567890123",
        months: 12,
        primeLineNumber: "2"
      },
      {
        WarrantyType: "Replacement",
        UnitPrice: "35.50",
        UnitOfMeasure: "EACH",
        WarrantyCondition: "New",
        ExtendedDisplayDescription: "Warranty SUPERIOR 200+ ",
        ItemID: "J09876543210987",
        months: 36,
        primeLineNumber: "3"
      }
    ];
  },
  getCartItemsFromOrderLines: (orderLines: ContainerDetail[]): CartItem[] => {
    return orderLines.map((orderLine) => ({
      sku: orderLine.ItemID || '',
      name: orderLine.ItemDesc || 'Unknown Item',
      quantity: parseInt(orderLine.Quantity || '1'),
      price: parseFloat(orderLine.UnitPrice || '0'),
      imageUrl: orderLine.ImageUrl || '/path/to/default-image.png',
      itemId: orderLine.ItemID || '',
      isWarrantyEligible: orderLine.IsWarrantyEligible === 'Y',
      isItemEligibleForWarranty: orderLine.IsItemEligibleForWarranty === 'Y',
      isWarrantyAlreadyAdded: orderLine.IsWarrantyAlreadyAdded === 'Y',
      primeLineNumber: orderLine.PrimeLineNo,
      quantityEligibleForPC: parseInt(orderLine.QuantityEligibleForPC)
    }));
  },

  getCommissions: async (): Promise<Commission[]> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve([...dummyCommissions]);
      }, 500);
    });
  },

  addCommission: async (newCommission: Omit<Commission, 'id'>): Promise<Commission> => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const percentageAsNumber = parseFloat(newCommission.percentage);

        if (!newCommission.employeeName || isNaN(percentageAsNumber) || percentageAsNumber <= 0 || percentageAsNumber > 100 || !newCommission.commissionType) {
          return reject(new Error('Invalid commission data. Percentage must be a number between 0 and 100.'));
        }

        const generatedId = `comm-${Date.now()}`;
        const addedCommission: Commission = { ...newCommission, id: generatedId, percentage: newCommission.percentage }; // Keep as string
        dummyCommissions.push(addedCommission);
        resolve(addedCommission);
      }, 500);
    });
  },

  // NEW: Method to update an existing commission
  updateCommission: async (updatedCommission: Commission): Promise<Commission> => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const index = dummyCommissions.findIndex(comm => comm.id === updatedCommission.id);

        if (index === -1) {
          return reject(new Error('Commission not found.'));
        }

        const percentageAsNumber = parseFloat(updatedCommission.percentage as string); // Parse to number for validation

        // Basic validation for the updated fields (optional but good practice)
        if (!updatedCommission.employeeNumber || !updatedCommission.employeeName || isNaN(percentageAsNumber) || percentageAsNumber <= 0 || percentageAsNumber > 100 || !updatedCommission.commissionType) {
          return reject(new Error('Invalid commission data. Percentage must be a number between 0 and 100.'));
        }

        dummyCommissions[index] = { ...updatedCommission, percentage: updatedCommission.percentage }; // Keep as string
        resolve(updatedCommission);
      }, 300); // Shorter timeout for inline updates
    });
  },

  completeOrder: async (orderData: { selectedItems: string[]; coverageMonths: number | null; paymentMethodId: string; commissions?: Commission[] }) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log("Completing Order with:", orderData);
        if (orderData.selectedItems.length > 0 && orderData.coverageMonths !== null && orderData.paymentMethodId) {
          resolve({ success: true, orderId: `ORDER-${Date.now()}` });
        } else {
          resolve({ success: false, error: 'Missing order details.' });
        }
      }, 1500);
    });
  }
};

export default apiService;